import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkOrder from './work-order';
import WorkOrderDetail from './work-order-detail';
import WorkOrderUpdate from './work-order-update';
import WorkOrderDeleteDialog from './work-order-delete-dialog';

const WorkOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkOrder />} />
    <Route path="new" element={<WorkOrderUpdate />} />
    <Route path=":id">
      <Route index element={<WorkOrderDetail />} />
      <Route path="edit" element={<WorkOrderUpdate />} />
      <Route path="delete" element={<WorkOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkOrderRoutes;
